var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_c(require('icons/Login').default,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }